import React from 'react';

const Tag = ({ tag }: { tag: string }) => (
  <p className='col-span-1 text-white bg-accent rounded-full text-center w-max px-4 py-1'>{tag}</p>
);

export default Tag;
